export interface Appliance {
    label: string,
    wattsPh: number,
    factor: number, /* If appliance uses 3000W per hour but switches on and off 2 times per hour, the factor will be 2 */
    daytime: number,
    nighttime: number,
    min: number,
    max: number,
    inc: number,
    usage: number,
    storage: number
}
